import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import API from '../../../../api/baseUrl';
import { useLocation } from 'react-router-dom';
import { MedProfile } from './types';
import { getTokens } from '../../../../auth/AuthState';

interface GetPatientMedProfilesResponse {
  medProfiles: MedProfile[];
  access_token: string;
  tenancyId: number;
}

export const useGetPatientMedProfiles = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [medProfiles, setMedProfiles] = useState<MedProfile[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');

  const postGetPatientMedProfiles = async () => {
    if (!selectedTenancy || !access_token) return;
    setIsLoading(true);
    try {
      const { id: authorization_token } = await getTokens();

      let options = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authorization_token,
        },
      };

      const payload = {
        access_token: access_token,
        tenancyId: selectedTenancy.tenancy_id,
      };
      const { data: result } = await API.post(
        `getPatientMedProfiles`,
        { ...payload },
        options,
      );
      const { data }: { data: GetPatientMedProfilesResponse } = result;
      if (Array.isArray(data.medProfiles)) {
        setMedProfiles(data.medProfiles);
      }
    } catch (error: any) {
      console.error('An error occurred during getPatientMedProfiles', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in getPatientMedProfiles',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postGetPatientMedProfiles,
    errorMessage,
    isLoading,
    medProfiles,
  };
};
